import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { useMilestoneContext } from "../context/MilestoneContext";
import { milestoneStyles } from "../styles/milestoneStyles";
import { milestoneHeaderSectionStyles } from "../styles/milestoneHeaderSectionStyles";
import CelebrationIcon from '@mui/icons-material/Celebration';
import ExpandIcon from '@mui/icons-material/Expand';

/**
 * Milestone header component that displays completion stats and expand/collapse functionality
 */
export const MilestoneHeaderSection: React.FC = React.memo(() => {
     const { getCompletedCounts, getTotalMilestones, toggleExpandAll, expandedAll } = useMilestoneContext();
     const [showCongratulation, setShowCongratulation] = useState(false);

     const progressPercentage = getTotalMilestones > 0
          ? (getCompletedCounts / getTotalMilestones) * 100
          : 0;

     const isAllCompleted = getCompletedCounts === getTotalMilestones && getTotalMilestones > 0;

     useEffect(() => {
          if (isAllCompleted && !showCongratulation) {
               setShowCongratulation(true);
               const timer = setTimeout(() => {
                    setShowCongratulation(false);
               }, 3000);
               return () => clearTimeout(timer);
          }
     }, [isAllCompleted, showCongratulation]);

     return (
          <Box sx={milestoneStyles.stickyHeader}>
               <Box sx={milestoneStyles.headerSection}>
                    <Typography variant="h6">
                         Milestones
                         <Typography component="span" sx={milestoneStyles.statusBadge}>
                              {getCompletedCounts} / {getTotalMilestones} Completed
                              {isAllCompleted && showCongratulation && (
                                   <Typography
                                        component="span"
                                        sx={milestoneHeaderSectionStyles.congratulationText}
                                   >
                                        <CelebrationIcon sx={milestoneHeaderSectionStyles.celebrationIcon} />
                                   </Typography>
                              )}
                              {!isAllCompleted && (
                                   <Box
                                        sx={{
                                             ...milestoneHeaderSectionStyles.progressCircle,
                                             animation: progressPercentage > 0 ? 'pulse 2s infinite' : 'none'
                                        }}
                                   />
                              )}
                         </Typography>
                    </Typography>
                    <Tooltip title={expandedAll ? "Collapse All" : "Expand All"} arrow placement="left">
                         <span>
                              <IconButton
                                   size="medium"
                                   onClick={toggleExpandAll}
                              >
                                   <ExpandIcon
                                             sx={{
                                                  transform: expandedAll ? 'rotate(180deg)' : 'rotate(0deg)',
                                                  transition: 'transform 0.2s ease-in-out'
                                             }}
                                   /> 
                              </IconButton>
                         </span>
                    </Tooltip>
               </Box>
          </Box>
     );
});

MilestoneHeaderSection.displayName = 'MilestoneHeaderSection';

export default MilestoneHeaderSection; 